import { defineStore } from 'pinia';
import api from '../services/api';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    isAuthenticated: !!localStorage.getItem('token')
  }),

  getters: {
    isAdmin: (state) => state.user?.rol === 'administrador' || state.user?.rol === 'superadministrador',
    isSuperAdmin: (state) => state.user?.rol === 'superadministrador',
    currentUser: (state) => state.user
  },

  actions: {
    async login(credentials) {
      try {
        const response = await api.post('/auth/login', credentials);
        const { token, user } = response.data.data;
        
        this.token = token;
        this.user = user;
        this.isAuthenticated = true;
        
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        return response.data;
      } catch (error) {
        throw error.response?.data || { message: 'Error al iniciar sesión' };
      }
    },

    async logout() {
      this.user = null;
      this.token = null;
      this.isAuthenticated = false;
      
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },

    async fetchCurrentUser() {
      try {
        const response = await api.get('/auth/me');
        this.user = response.data.data;
        localStorage.setItem('user', JSON.stringify(this.user));
        return response.data;
      } catch (error) {
        this.logout();
        throw error;
      }
    }
  }
});